// <title> 與 og:title 的組法（規範：Obsidian 25 號〈全站標題與命名規範〉§3.1–3.3）。
// route.meta.title 存「頁面主體」；作者後綴依語系接：中文「｜吳哲宇」（全形、前後不空格）、英文「 | Che-Yu Wu」。
// 主體已含「吳哲宇」或「Che-Yu Wu」的（首頁、簡介、履歷、聯絡四張人物頁、「… by Che-Yu Wu」）不再接，名字只出現一次。
// scripts/lib/route-titles.cjs 的 assemble() 是同一行為；scripts/test-title-contract.cjs 逐條比對。
export const SITE_NAME = 'Che-Yu Wu 吳哲宇'
const hasName = t => t.includes('吳哲宇') || t.includes('Che-Yu Wu')

export function composeTitle(body, locale) {
  if (!body || body === SITE_NAME) return body || SITE_NAME
  if (hasName(body)) return body
  return locale === 'zh' ? `${body}｜吳哲宇` : `${body} | Che-Yu Wu`
}

// 中文標題的首尾不留括號（2026-10-18；由來見 scripts/lib/route-titles.cjs 的 zhTitle）：開頭的《名》拿掉《》（《咖啡幻夢》策展訪談：… → 咖啡幻夢策展訪談：…），
// 結尾的（副題）改成冒號副題（…調查（極致覆盤） → …調查：極致覆盤；已有冒號時用「・」）。句中的「」不動。
// 對話錄詳情頁自己組 <title>（pageDialogueDetail.vue 的 headTitle，不走 route meta），所以這支要在執行端也有；
// route-titles.cjs 的 unwrapZhEdges 是同一行為，test-title-contract.cjs 逐條比對。
export function unwrapZhEdges(title) {
  let s = String(title ?? '')
  const lead = s.match(/^《([^《》]+)》(.+)$/)
  if (lead) s = lead[1] + lead[2]
  const tail = s.match(/^(.*[^（）])（([^（）]+)）$/)
  if (tail) s = tail[1] + (/[：:]/.test(tail[1]) ? '・' : '：') + tail[2]
  return s
}

// og:title／twitter:title：頁面主體，不含作者後綴（人物頁自帶的「｜吳哲宇 Che-Yu Wu」、「… by Che-Yu Wu」一併去掉）；首頁名字在前，原樣
export function ogTitle(body, locale) {
  const t = body || SITE_NAME
  const bare = t.replace(/｜吳哲宇( Che-Yu Wu)?$/, '').replace(/ \| Che-Yu Wu( 吳哲宇)?$/, '').replace(/ by Che-Yu Wu$/, '')
  return bare || composeTitle(body, locale)
}
